import * as React from 'react';
import { InlineText2 } from '@cian/ui-kit/typography';
import * as style from './BasicInfoLink.css';
import { Link } from '../../../Link';

export interface IBasicInfoLinkProps {
  text: string;
  linkUrl: string;
  onClick?(): void;
}

export const BasicInfoLink: React.FC<IBasicInfoLinkProps> = props => {
  const { text, linkUrl, onClick } = props;

  return (
    <Link url={linkUrl} linkStyle={{ display: 'flex' }} target={'blank'} onClick={onClick}>
      <div className={style['text']}>
        <InlineText2 color={'white_100'} fontWeight={'bold'}>
          {text}
        </InlineText2>
      </div>
    </Link>
  );
};

BasicInfoLink.displayName = 'BasicInfoLink';
